import React, { PropsWithChildren, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IconS24Minus24, IconS24Plus24 } from '@is24/cosma-ui-icons'
import { useEffectWithExecutionCount } from './useEffectWithExecutionCount'

type SearchFieldAdditionalProps = {
  initiallyVisible: boolean
}
export const ApiSearchFieldToggler: React.FC<PropsWithChildren<SearchFieldAdditionalProps>> = ({
  children,
  initiallyVisible,
}) => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(initiallyVisible)
  useEffectWithExecutionCount(
    (effectExecutionCount) => {
      if (effectExecutionCount === 1) {
        setVisible(initiallyVisible)
      }
    },
    [initiallyVisible]
  )

  return (
    <>
      <div className='grid-item'>
        <p className={'font-default-color'}>{t('wizard.screen.apiSearchData.togglerHint')}</p>
        <button
          type='button'
          className='link-text background-none border-none margin-top-s padding-none'
          onClick={() => setVisible((visible) => !visible)}
        >
          {visible ? (
            <IconS24Minus24 inline className='margin-right-xs' width={16} height={16} />
          ) : (
            <IconS24Plus24 inline className='margin-right-xs' width={16} height={16} />
          )}
          {t('wizard.screen.apiSearchData.togglerText')}
        </button>
      </div>
      <div className='grid-item'>{visible && children}</div>
    </>
  )
}
